// Depricated
export default function reserverFlightFactory(ajax) {
  return async function reserverFlight({ flight_id, return_flight_id }) {
    const data = return_flight_id ? { flight_id, return_flight_id } : { flight_id };
    return ajax({
      resource: 'flights/reservation',
      method: 'post',
      data,
    });
  };
}



// WEBPACK FOOTER //
// ./src/services/reserveFlight.js